import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData} from '../../../Redux/actions/packageActions'

import {errorParser} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,onCloseModal}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)

    const componentRef = useRef();
    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [destination, setDestination] = useState(null)
    const [destinationName, setDestinationName] = useState(null)
    const [packItems, setPackItems] = useState([])



    useEffect(() => {
 
    },[]);


    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
    useEffect(() => {
      if(currentItem){
        setIsModalVisible(true)
        setPackItems(currentItem.items)
      }
    },[currentItem]);






    
    const closeModal = (action) =>{
      if(!loading){
        setPackItems([])
        setIsModalVisible(false);       
        onCloseModal()
      }
    }

    const deleteThis =(id) =>{
      dispatch(deleteCartItem(id))
      .then(res=>{
        dispatch(getCart())
      })
    }

    const changeCartCount = (id,qty) =>{
      var newdata={
        quantity: qty
      }
      dispatch(editCartItem(newdata,id))
    }

    const PrintThis =() =>{
      return(
        <div ref={componentRef} >
        hi
      </div> 
      )


    }

    return(       
      <>   
      <div className={'printItemhide'}>
      <ComponentToPrint ref={componentRef} pageStyle={pageStyle} currentItem={currentItem}/>
      </div>
   
      <Button onClick={(e)=>{e.stopPropagation(); handlePrint();}}>Print Packing List</Button>

      </>
    )
}
  
export default Index
  

const pageStyle = `
  @page {
    size: 210mm 297mm;
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      margin-top: 1rem;
      page-break-before: always;
    }
  }
`;

const ComponentToPrint = React.forwardRef((props, ref) => {

  const { user,cart,locations } = useSelector(state => ({
    user: state.auth.user,
    cart: state.cart.data,
    locations: state.locations.locations 
  }), shallowEqual)

  // console.log(props.currentItem)
  var dest = locations.filter(i =>i.id == props.currentItem.destination)
    var destData = dest[0]
    
  const packagewaybill = () =>{

    return(
    
        <div className={'packinglist_content'}>
          <div className='row spcbtwn'> 
            <h2>   {props.currentItem.destination_name}(ORDER)</h2>
            
           <h2 className={''}>{`pck_${props.currentItem.id}`}</h2>
           
           <span className={''}>{`${moment(props.currentItem.created_at).format('LLL')}`}</span> 
          </div>
          <div className='row spcbtwn'> 
         
            <div className='row spcbtwn'> 

     
              <span> {destData.contact_person} </span>
              <span className={''}> {destData.contactno}</span>   
              <span className={''}> {destData.address}</span>  
            </div> 
 
          </div> 
            
          <div className='row flexcenter '> 
            
            <h2 className={''}>{`items: ${props.currentItem.items.length}`}</h2>    
          </div> 
        </div>  
  
    
    )
  }

  const packageItemWaybill = (item) =>{

    return(
     
        <div className={'itemtopack row'}>
            <span className={'pckitem'}> {item.product_name}</span>  
            <span className={'pckitemqty'}>{`${item.quantity} ${item.unit}`}</span>    
                               
        </div>  
   
    
    )
  }
  



  return (
    <div ref={ref}  pageStyle={pageStyle} className={'packinglist_container'}> 
      {packagewaybill()}
      <div  className={'packinglist'} key={props.currentItem.destination_name}>   
      {props.currentItem.items.map(x=>{
        return(packageItemWaybill(x))
      })}

    </div>
     
    </div>
  );
});